import roofingSolarCombined from "@/assets/blog/roofing-solar-combined.jpg";
import roofReplacementSigns from "@/assets/blog/roof-replacement-signs.jpg";
import solarSavings from "@/assets/blog/solar-savings.jpg";

const map: Record<string, string> = {
  "roofing-solar-combined.jpg": roofingSolarCombined,
  "roof-replacement-signs.jpg": roofReplacementSigns,
  "solar-savings.jpg": solarSavings,
};

export function resolveBlogImage(src: string): string {
  if (!src) return roofingSolarCombined;
  if (/^https?:\/\//i.test(src) || src.startsWith("/")) return src;
  return map[src] ?? roofingSolarCombined;
}
